export enum TextManipulationTag {
  DIV = 'div',
  SPAN = 'span',
  P = 'p',
  H2 = 'h2',
  A = 'a',
}